import { classNames } from '@commenda/utils';
import React from 'react';
import { TableActionCloseButton } from './TableActionCloseButton';

interface TableGlobalActionTriggerProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  count: number;
  onClear: () => void;
  icon: React.ReactNode;
  label: string;
}

const TableGlobalActionTrigger = React.forwardRef<
  HTMLButtonElement,
  TableGlobalActionTriggerProps
>(({ count, onClear, icon, label, className, ...props }, ref) => {
  const isActive = count > 0;

  return (
    <button
      ref={ref}
      type="button"
      className={classNames(
        'flex items-center justify-center gap-sm py-sm px-md rounded-md transition-all duration-200 outline-none focus:outline-none',
        isActive
          ? 'bg-bg-brand hover:bg-bg-brand-hover text-fg-brand hover:text-fg-brand-hover'
          : 'bg-bg-primary hover:bg-bg-primary-hover text-text-tertiary hover:text-text-tertiary-hover',
        className || ''
      )}
      aria-label={`${label}${isActive ? ` (${count} active)` : ''}`}
      {...props}
    >
      {icon}
      <span className="txt-small-medium">
        {label} {isActive && `(${count})`}
      </span>
      {isActive && <TableActionCloseButton onClick={onClear} />}
    </button>
  );
});

TableGlobalActionTrigger.displayName = 'TableGlobalActionTrigger';

export { TableGlobalActionTrigger };
